import { MultiStepFormState } from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form-item';
import { SubmitHandlerWithDirtyFields } from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form.provider';
import { getGetUsersPaginatedDefaultValues } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/users/models/inputs/get-users-paginated.form-default-values';
import { GetUsersPaginatedModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/users/models/inputs/get-users-paginated.model';
import { useState } from 'react';
import { SubmitErrorHandler } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

import { Logger } from '@app/core/logger/logger';

import {
  FilterUserListContextProvider,
  useUserListContext,
} from '../user.context';
import { UserListFilterFormController } from './user-list-filter-form/user-list-filter-form.controller';

interface UserListFilterControllerProps {
  onCancel: () => void;
  onSuccess: () => void;
}

export const UserListFilterController = ({
  onCancel,
  onSuccess,
}: UserListFilterControllerProps): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { t } = useTranslation();
  const { getPaginatedQueryParameters, setGetPaginatedQueryParameters } =
    useUserListContext();
  const [multiStepFormState] = useState(MultiStepFormState.Default);

  // HANDLERS //////////////////////////////////////////////////////////////////

  const handleError: SubmitErrorHandler<GetUsersPaginatedModel> = (errors) => {
    Logger.error(errors);
    toast.error(t('$.user-list-filter.error', { error: t('global.unknown') }));
  };

  const handleSubmit: SubmitHandlerWithDirtyFields<GetUsersPaginatedModel> = (
    fieldValues,
  ) => {
    setGetPaginatedQueryParameters((current) => {
      return {
        ...current,
        customerId: fieldValues.customerId,
        roleId: fieldValues.roleId,
      };
    });
    onSuccess();
  };

  // RENDER ////////////////////////////////////////////////////////////////////

  const data = getGetUsersPaginatedDefaultValues(getPaginatedQueryParameters);

  return (
    <FilterUserListContextProvider data={data}>
      <UserListFilterFormController
        onError={handleError}
        onSubmit={handleSubmit}
        onCancel={onCancel}
        state={multiStepFormState}
      />
    </FilterUserListContextProvider>
  );
};
